import React, { useContext, useEffect, useState } from 'react';
import { Carousel, CarouselNavigation, CarouselSlide, CarouselWrapper } from '$partials/base/carousel';
import { Image } from '$partials/media';
import { ArrowRightIcon } from '$partials/icon';
import { StaffModal } from '$partials/modals';
import { ModalContext } from '$contexts/modal.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').AutomatedStaffCarousel}
 */
const AutomatedStaffCarousel = ({
    title,
    items
}) => {
    const { handleModal } = useContext(ModalContext);
    const [shuffledItems, setShuffledItems] = useState([...(items || [])]);

    const shuffle = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };

    useEffect(() => {
        setShuffledItems(shuffle([...items]));
    }, [items]);

    if (!items?.length) {
        return null;
    }

    return (
        <Carousel swiperConfig={{
            slidesPerView: 'auto',
            spaceBetween: 2,
            breakpoints: {
                640: {
                    slidesPerView: 'auto'
                },
                1024: {
                    slidesPerView: 'auto'
                }
            },
        }}>
            <section className='overflow-hidden container featured-staff-carousel-container overhang-left md-overhang-left-0'>
                <header className='col-12 flex items-center justify-between px5 md-px6 py5 md-py7 border-bottom grey bg-white'>
                    <h2 className='type-style-2 black'>
                        {title}
                    </h2>
                    <div className='hide md-show'>
                        <div className='flex flex-row items-center'>
                            <CarouselNavigation look='row'/></div>
                    </div>
                </header>
                <CarouselWrapper className='swiper-wrapper'>
                    {shuffledItems?.map((item, i) => {
                        const page = item;

                        if (!page) { return null; }
                        const image = page.profileImage;
                        return (
                            <CarouselSlide
                                className='flex carousel-slide'
                                index={i}
                                key={`featured-staff-carousel-${page?.id}-${i}`}>
                                <div
                                    className='cursor-pointer flex flex-col bg-white px5 md-px6 pt5 pb8 sm-pb6 md-pt6 md-pb9 border-top grey'
                                    onClick={() => handleModal(
                                        <StaffModal {...page}/>
                                    )}>
                                    <div
                                        className='carousel-item-fixed-height'>
                                        <div
                                            style={{
                                                width: `${(image?.width / image?.height)}em`
                                            }}>
                                            <div className='carousel-item-height'>
                                                <Image {...image}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt5 black'>
                                        {/* Job title */}
                                        {page.jobTitle && (
                                            <p className='type-style-5'>
                                                {page.jobTitle}
                                            </p>
                                        )}
                                        {/* Name */}
                                        <h3 className='type-style-3'>
                                            {page.name}
                                        </h3>

                                        {/* CTA */}
                                        <button
                                            className='mt6 md-hide form-field-reset link-reset inline-flex items-center type-style-5 cursor-pointer'
                                            onClick={() => handleModal(
                                                <StaffModal {...page}/>
                                            )}
                                            type='button'>
                                            <span>
                                                Contact
                                            </span>
                                            <span
                                                aria-hidden={true}
                                                className='font-0 line-height-0 ml5 mtn1'>
                                                <ArrowRightIcon/>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </CarouselSlide>
                        );
                    })}
                </CarouselWrapper>
            </section>
        </Carousel>

    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default AutomatedStaffCarousel;
